import Swal from 'sweetalert2'

export const userKey = '_Sollicita.Orientacoes'
export const rememberKey = '_Sollicita.Orientacoes_remember'

var urlBase = 'sollicita.com.br';

export var urlApi = ''
export var urlApiSollicita = ''

export var urlSollicita = 'https://sollicita.com.br/';
export var urlFerramentas = '';
export var urlMural = '';
export var urlPortal = '';
export var urlPlanos = 'https://sollicita.com.br/Planos';
export var urlSuporte = 'https://gnp.negociospublicos.net.br/np/suporte/login?';


var dev = false;
if (dev) {

    // local
    urlApi = 'https://localhost:44324/api/v1'
    //export const urlApi = 'http://localhost:64/api/v1'

    urlApiSollicita = 'http://localhost:82/NP/SollicitaAdmin/api'
    //export const urlApiSollicita = 'https://gnp.negociospublicos.net.br/NP/SollicitaAdmin/api'

    urlFerramentas = 'http://localhost:8081/';
    urlMural = 'http://localhost:8081/';
    urlPortal = 'http://localhost:8081/';
    urlSuporte = 'http://localhost:82/np/suporte/login?';
} else {
    urlApi = 'https://api.' + urlBase + '/api/v1';
    urlApiSollicita = 'https://gnp.negociospublicos.net.br/NP/SollicitaAdmin/api'

    urlFerramentas = 'https://' + urlBase + '/';
    urlMural = 'https://mural.' + urlBase + '/';
    urlPortal = 'https://portal.' + urlBase + '/';
}

export function avisoErro(e) {
    if (e && e.response && e.response.data) {
        //alert(e.response.data);
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: e.response.data,
        })
    } else if (typeof e === 'string') {
        //alert(e);
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: e,
        })
    } else {
        //alert('Erro');
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: e,
        })
    }
}

export function avisoSucesso(msg) {
    Swal.fire({
        icon: 'success',
        title: 'Sucesso',
        text: msg,
    })
}

export function getIconeTipoPergunta(nmTipoPergunta) {
    switch (nmTipoPergunta) {
        case 'Estudo Técnico':
            return 'fas fa-clipboard-list';
        case 'Resposta Objetiva':
            return 'far fa-clock';
        case 'Atendimento Telefônico':
            return 'fas fa-phone-alt';
        case 'Atendimento via WhatsApp':
            return 'fab fa-whatsapp';
        case 'Mentoria Online':
            return 'fas fa-laptop';

        default:
            return '';
    }
}

export default { userKey, rememberKey, urlApi, avisoErro, avisoSucesso, getIconeTipoPergunta, urlApiSollicita, urlFerramentas, urlMural, urlPortal, urlSollicita, urlPlanos, urlSuporte }